import { FormattedMessage } from 'react-intl'
import { useIntercom } from 'react-use-intercom'

import { getImage } from '@/lib/images'
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Typography,
} from '@/shared/ui'

type Props = {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}

export const ProofOfAddressInfoDialog = ({ isOpen, onOpenChange }: Props) => {
  const { showArticle } = useIntercom()

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <img
          className="animate-shake mx-auto w-36 object-contain"
          src={getImage({
            name: 'map-location',
          })}
          alt=""
          aria-hidden
        />
        <DialogHeader>
          <DialogTitle>
            <FormattedMessage
              defaultMessage="Owner's proof of address"
              id="kyb.proofOfAddress.title"
            />
          </DialogTitle>

          <DialogDescription>
            <FormattedMessage
              defaultMessage="We need to collect a few more details about the company owners, this will only take a minute or two"
              id="kyb.proofOfAddress.dialog.subtitle"
            />
          </DialogDescription>
        </DialogHeader>

        <div className="p-3" />

        <Button onClick={() => onOpenChange(false)} size="xl" width="full">
          <FormattedMessage id="action.continue" defaultMessage="Continue" />
        </Button>

        <div className="p-3" />

        <Typography
          variant="body-small"
          text="center"
          className="text-neutral-gray-600"
        >
          <FormattedMessage
            defaultMessage="Why am I being asked this? {learnMore}"
            id="2fa.dialog.required.footer"
            values={{
              learnMore: (
                <Button
                  onClick={() => showArticle(10205735)}
                  className="text-xs"
                  variant="link"
                  size="inline"
                >
                  <FormattedMessage
                    defaultMessage="Learn more"
                    id="label.learnMore"
                  />
                </Button>
              ),
            }}
          />
        </Typography>
      </DialogContent>
    </Dialog>
  )
}
